/*
 * groupId = consent-group (C0001, C00002...)
 * return values:
 *      true = consent for this group is given
 *      false = consent for this group is not given
 *      null = OneTrust is not used on this website
 */

export function consentCheck (groupId) {
  if (typeof OnetrustActiveGroups !== 'undefined') {
    return RegExp(`(${groupId})`).test(OnetrustActiveGroups)
  }
  return null
}
